module.exports = __webpack_public_path__ + "static/media/ambassadors.95a0817c.png";